/**
 * Parse an emailed invite landing URL.
 *
 * The High Holiday (and year-round) invite emails link to `/invite?email=`,
 * which opens the Redeem modal instead of dumping the member on the
 * homepage to hunt for "Sign in → Have an invite code?".
 *
 * The 6-digit code is NEVER put in the URL — it is a credential, and
 * email-client previews, server logs, and browser history would all
 * keep a copy. Only the email is prefilled, and only after it passes
 * the same format check the form uses.
 *
 * `?invite=1` on any other path is accepted too, so an older bookmark
 * or a homepage link still works if `/` happens to redirect to `/home`.
 */
import { validateEmail } from './inviteVerification';

export const parseInviteDeepLink = (search = '', pathname = '') => {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  const params = new URLSearchParams(search);
  const isInvitePath = path === '/invite';
  const flagged = isInvitePath || params.get('invite') === '1';
  if (!flagged) return { open: false, email: '' };

  const raw = params.get('email') || '';
  const check = validateEmail(raw);
  return { open: true, email: check.valid ? check.formatted : '' };
};

export const inviteLandingPath = (email) => {
  const trimmed = String(email || '').trim().toLowerCase();
  const check = validateEmail(trimmed);
  if (!check.valid) return '/invite';
  return `/invite?email=${encodeURIComponent(check.formatted)}`;
};
